import { render, staticRenderFns } from "./UsuariosHolder.vue?vue&type=template&id=6c937006"
import script from "./UsuariosHolder.vue?vue&type=script&lang=js"
export * from "./UsuariosHolder.vue?vue&type=script&lang=js"
import style0 from "./UsuariosHolder.vue?vue&type=style&index=0&id=6c937006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports